<template>
	<div class='chinese opacity-87 container mx-auto text-center text-base text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl
	mt-18 sm:mt-24 md:mt-32 lg:mt-40'>
    <p>囧</p>
    <p>404 Not Found</p>
    <router-link :to='{ name: "landing" }'
    class='btn bg-teal-500 mt-8 px-3 py-1 
    text-base sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl rounded-lg'
    >
      Home | 返回
    </router-link>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
